import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
const Rapport_API = "https://notregrandbleu.herokuapp.com/rapport/";

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" })
};
@Injectable({
  providedIn: 'root'
})
export class RapportService {

  public afficherRapport(): Observable<any> {
    return this.http.get(Rapport_API , httpOptions);
  }

  addRapport(rapport): Observable<any> {
    return this.http.post(Rapport_API + "addRapport", rapport ,httpOptions );
  }
  deleteRapport(id): Observable<any> {
    return this.http.get(Rapport_API + "supprimer/"+ id ,httpOptions );
  }
  modify(rapport):Observable<any>
  {
    return this.http.put(Rapport_API+ "modifier" ,  rapport , httpOptions );
  }

  constructor(private http: HttpClient) { }
}
